"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Chevron = ({ color = "var(--ad-icon-color)", style = {} }) => {
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "20", height: "20", viewBox: "-3 -1 17 19", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: style }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M7.94583 0.929199L0.875 8.00003L7.94583 15.0709L9.125 13.8925L3.23167 8.00003L9.125 2.10753L7.94583 0.929199Z", fill: color }) })));
};
exports.default = Chevron;
